import { render } from "./AdmissionsManagement.vue?vue&type=template&id=37c78fd9&scoped=true"
import script from "./AdmissionsManagement.vue?vue&type=script&lang=js"
export * from "./AdmissionsManagement.vue?vue&type=script&lang=js"

import "./AdmissionsManagement.vue?vue&type=style&index=0&id=37c78fd9&lang=css"
import "./AdmissionsManagement.vue?vue&type=style&index=1&id=37c78fd9&scoped=true&lang=css"

import exportComponent from "/Applications/PROJECTS/HMS-MAIN/PORTAL/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-37c78fd9"]])

export default __exports__